import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Skills from "./views/Skills.vue";
import Projects from "./views/Projects.vue";
import Project from "./views/Project.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,

  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      afterEach: (to, from) => {
        showNav = false;
      }
    },
    {
      path: "/skills",
      name: "skills",
      component: Skills
    },
    {
      path: "/projects",
      name: "projects",
      component: Projects
    },
    {
      path: "/project/:slug",
      name: "project",
      component: Project
    }
  ]
});
